// extracted by mini-css-extract-plugin
export var divider = "_o4-0";
export var systemMessage = "_o4-1";
export var systemMessageWrapper = "_o4-2";